import React from 'react';
import styles from './ListingHeader.module.css';

const ListingHeader = ({
    title,
    description,
    actions,
    filters,
    className = ""
}) => {
    return (
        <div className={`${styles.headerWrapper} ${className}`}>
            <div className={styles.titleSection}>
                <div className={styles.textGroup}>
                    {title && <h1 className={styles.title}>{title}</h1>}
                    {description && <p className={styles.description}>{description}</p>}
                </div>
                {actions && <div className={styles.actionsGroup}>{actions}</div>}
            </div>

            {filters && (
                <div className={styles.filtersSection}>
                    {filters}
                </div>
            )}
        </div>
    );
};

export default ListingHeader;
